<h1 mat-dialog-title>Snack availability for {{ data.teamName }}</h1>

<div mat-dialog-content class="edit-team-snacks-dialog-content">
  <div class="setting-mode-panel">
    <p class="setting-mode-help">
      Select the company-available snack panels this team can see on the customer app Explore page.
    </p>
  </div>

  <app-inlinemessage
    *ngIf="rewards.length === 0"
    level="warning"
    message="No company-available snack rewards are available to select.">
  </app-inlinemessage>

  <div class="snack-editor-layout" *ngIf="rewards.length > 0">
    <section class="snack-list-panel">
      <div class="snack-reward-toolbar">
        <span>{{ getSelectedCount() }} of {{ rewards.length }} selected</span>
        <button
          mat-button
          type="button"
          [disabled]="getSelectedCount() === 0"
          (click)="clearSelected()">
          Clear
        </button>
      </div>

      <div class="snack-reward-list">
        <div
          class="snack-reward-row"
          [class.no-image]="!reward.imageUrl"
          [class.selected-row]="isSelected(reward.id)"
          [class.preview-row]="isPreviewed(reward.id)"
          (click)="previewReward(reward)"
          *ngFor="let reward of rewards; trackBy: trackReward">
          <mat-checkbox
            class="snack-reward-checkbox"
            (click)="$event.stopPropagation()"
            (change)="toggleReward(reward.id, $event.checked)"
            [checked]="isSelected(reward.id)">
          </mat-checkbox>

          <div class="reward-image" *ngIf="reward.imageUrl">
            <img [src]="reward.imageUrl" [alt]="reward.title" />
          </div>

          <div class="reward-text">
            <div class="reward-title">{{ reward.title }}</div>
            <div class="reward-subtitle" *ngIf="reward.subtitle">{{ reward.subtitle }}</div>
          </div>

          <button
            mat-icon-button
            type="button"
            matTooltip="Preview Explore panel"
            [class.active-preview-button]="isPreviewed(reward.id)"
            (click)="previewReward(reward, $event)">
            <mat-icon>visibility</mat-icon>
          </button>
        </div>
      </div>
    </section>

    <aside class="snack-preview-panel">
      <app-snack-reward-preview [reward]="getPreviewReward()"></app-snack-reward-preview>
    </aside>
  </div>
</div>

<div class="buttons edit-team-snacks-actions" mat-dialog-actions>
  <button mat-raised-button class="donebutton" color="primary" (click)="okClicked()">Done</button>
  <button mat-button (click)="onDismiss()">Cancel</button>
</div>
